<template>
    <!-- <div> -->  
        <div v-if="type === 500" class="notification">
            <div class="notification__inner">
                <p class="text">
                    {{ props.msg }}
                </p>
                <button type="button" class="close">닫기</button>
            </div>
        </div>
    <!-- </div> -->
</template>

<script setup>
import { onMounted, ref, watch, computed, defineEmits } from 'vue';

const props = defineProps({
    type: {
        default: 100,
        required: true,
    },
    msg: {
        default: 'msg_msg_msg_msg_msg_msg_msg_msg_msg_msg_',
        required: true,
    },
});
const emit = defineEmits(['onReturn']);

const type = computed(() => {
    return props?.type;
});

// const btnType = computed(() => {
//     return props?.type;
// });

const onClick = () => {
    // console.log('--onClick  --', props.label);
    emit('onReturn');
};
// onMounted(() => {});
</script>

<style scoped lang="scss"></style>
